import ApiClient from './apiClient'
import { QueriesApi } from './apiTypes'


const volumeSnapshotsService = {
  getSnapshotList:(queries:QueriesApi) => ApiClient.get('openstack/volumesnapshots', {
    params:{
      page: queries.page,
      page_size: queries.page_size || queries.pageSize,
      ordering: queries.ordering,
      search: queries.search,
      filtering: queries.filtering,
    }
  }),
  getSnapshot:(snapshotId:string) => ApiClient.get(`openstack/volumesnapshots/${snapshotId}`),
  createSnapshot:(data:any) => ApiClient.post(`openstack/volumesnapshots`, data),
  updateSnapshot:(snapshotId:string, data:any) => ApiClient.put(`openstack/volumesnapshots/${snapshotId}`, data),
  deleteSnapshot:(snapshotId:string) => ApiClient.delete(`openstack/volumesnapshots/${snapshotId}`),
  resetState:(snapshotId:string, data:any) => ApiClient.post(`openstack/volumesnapshots/${snapshotId}/reset_state`, data),
  getPrice:(data:any) => ApiClient.get('openstack/volumesnapshots/get_price', {
    params: data
  }),
  getSnapshotForRevert:(volumeId:string) => ApiClient.get(`openstack/volumesnapshots/get_snapshot_for_revert`, {
    params: { volume_id: volumeId }
  }),
}

export default volumeSnapshotsService
